import { Linking } from 'react-native';
import type { AlertButton } from '@/components/WebAlert';
import { APP_CONSTANTS } from '@/config/constants';
import type { ChecklistMediaResult } from './ChecklistImageService';
import globalState from '@/state/globalState';
import { showToast } from '@/utils/toast';

type ShowMessage = (title: string, message: string, buttons?: AlertButton[]) => void;
export const showChecklistMediaFeedback = (
  result: ChecklistMediaResult, label: 'Foto' | 'Assinatura' | 'Marcação', show: ShowMessage,
  onChange: (uri: string) => void,
): void => {
  if (result.superseded) return;
  const support: AlertButton = { text: 'Falar com suporte', onPress: () => { void Linking.openURL(APP_CONSTANTS.CONTACTS.WHATSAPP_URL); } };
  if (result.success && result.data?.uri) {
    const remote = result.remoteAcknowledged === true;
    const offlineConfirmed = globalState.network.lastChecked.get() !== null &&
      globalState.network.isConnected.get() === false;
    const queuedOffline = !remote && offlineConfirmed;
    const message = remote ? `${label} salva e enviada.`
      : `${label} salva.${queuedOffline ? ' Será sincronizada ao reconectar.' : ''}`;
    showToast(message, { type: 'success', duration: queuedOffline ? 4000 : 1800 });
  } else if (result.recoveryPending && result.retry) {
    let retrying = false;
    show('Captura preservada', `Não foi possível concluir o salvamento da ${label.toLowerCase()}. A captura foi preservada neste dispositivo para tentar novamente.`, [
      { text: 'Fechar', style: 'cancel' },
      { text: 'Tentar novamente', onPress: () => {
        if (retrying) return;
        retrying = true;
        void result.retry!().then(next => {
          if (next.success && next.data?.uri) onChange(next.data.uri);
          showChecklistMediaFeedback(next, label, show, onChange);
        }).catch(() => show('Não foi possível salvar', 'Tente novamente. Se o problema continuar, fale com o suporte.', [support, { text: 'OK' }]))
          .finally(() => { retrying = false; });
      } }, support,
    ]);
  } else {
    show('Não foi possível salvar', `Não foi possível confirmar o salvamento da ${label.toLowerCase()}. Tente novamente. Se o problema continuar, fale com o suporte.`, [support, { text: 'OK' }]);
  }
};
